import { post } from '@webapp-next/lib/request/webapp/apiv2';

/**
 * Get an employee's current regular schedule
 * @param { Number } employeeId
 * @param { Boolean } isBaseline
 * @param { String } date
 * @return {Promise<{success: boolean, message: *}|{data: null, success: boolean}|{data: *, success: boolean}>}
 */
export async function agreedHoursGetCurrent(employeeId, isBaseline, date) {
  const body = {
    isBaseline: isBaseline,
    date: date,
  };

  try {
    const { data } = await post(
      `/api/management/v2/agreed_hour/employee/${employeeId}`,
      body
    );
    if (!data.error) {
      return {
        success: true,
        data: data?.agreedHour,
        message: '',
      };
    } else {
      return {
        success: false,
        data: [],
        message: data?.error,
      };
    }
  } catch (e) {
    console.error('agreedHoursGetCurrent get error', e);
    return {
      success: false,
      data: [],
      message: e?.response?.data?.error?.message,
    };
  }
}

/**
 * Get regular schedules between the startDate and endDate
 * strict option controls whether to return the current regular schedule if it is before the startDate
 * @param { Number } employeeId
 * @param { Boolean } isBaseline
 * @param { String } startDate
 * @param { String } endDate
 * @param { Boolean } strict
 * @param { Boolean } includePending
 * @param { Boolean } includeDeclined
 * @param { String } currentDate
 * @return {Promise<{success: boolean, message: *}|{data: any, success: boolean}>}
 */
export async function agreedHoursSearch(
  employeeId,
  isBaseline,
  startDate,
  endDate,
  strict = false,
  includePending = false,
  includeDeclined = false,
  currentDate = null
) {
  const body = {
    isBaseline: isBaseline,
    startDate: startDate,
    endDate: endDate,
    strict: strict,
    includePending: includePending,
    includeDeclined: includeDeclined,
  };
  if (currentDate) {
    body.currentDate = currentDate;
  }

  try {
    const { data } = await post(
      `/api/management/v2/agreed_hours/${employeeId}`,
      body
    );
    return {
      success: true,
      data: data,
      message: '',
    };
  } catch (e) {
    // TODO: If no agreed hours found, a 404 error is returned. Remove when fixed.
    if (e?.message === 'Request failed with status code 404') {
      return {
        success: false,
        data: [],
        message: '404',
      };
    }

    console.error('agreedHoursSearch get error', e);
    return {
      success: false,
      data: [],
      message: e?.response?.data?.error?.message,
    };
  }
}
